import { createAction } from 'redux-actions';

import { RESET_BACK_LINK } from 'shared/store/app/actions';

export const resetBackLink = createAction(RESET_BACK_LINK);
